export const tournamentThemes = {
  classic: {
    // Sidytor
    page: "bg-[#f3f0e7]",
    section: "bg-[#fffdf8]",
    sectionMuted: "bg-[#f7f4ec]",

    // Golfgrönt
    primary: "bg-[#183d2d]",
    primaryHover: "hover:bg-[#214d39]",
    primarySoft: "bg-[#e5ede7]",

    // Text
    textPrimary: "text-[#1f2d26]",
    textSecondary: "text-[#68716c]",
    textOnPrimary: "text-[#fffdf8]",
    heading: "text-[#183d2d]",

    // Accent
    accent: "text-[#9a7735]",
    accentBackground: "bg-[#b08b45]",
    accentSoft: "bg-[#f2ead9]",

    // Linjer
    border: "border-[#d8d2c4]",
    borderStrong: "border-[#b8b09f]",

    // Resultat
    positive: "text-[#287148]",
    negative: "text-[#a0443e]",
    total: "text-[#183d2d]",

    // Tabeller
    tableHeader: "bg-[#183d2d] text-[#fffdf8]",
    tableRow: "bg-[#fffdf8]",
    tableRowAlternate: "bg-[#f7f4ec]",
    stickyColumn: "bg-[#eee9dc]",
  },
};

export function getTournamentTheme(themeKey = "classic") {
  return tournamentThemes[themeKey] ?? tournamentThemes.classic;
}